module.exports = __webpack_public_path__ + "img/gift-pattern.663acbd5.png";